<template>
    <button @click="onClick ? onClick($event) : emitClick($event)" :class="[ 'app-button', 'btn', size]" :disabled="loading || disabled">
        <slot />
        <loading-dots v-if="loading" :fill="loadingDotsFill" />
    </button>
</template>

<script>
const LoadingDots = () => import('@/components/svg/loading-dots.vue');

export default {
    components: {
        'loading-dots': LoadingDots
    },

    props: {
        onClick: {
            type: [Function]
        },

        loading: {
            type: Boolean,
            default: false
        },

        loadingDotsFill: {
            type: String,
            default: '#ffffff',
        },

        disabled: {
            type: Boolean,
            default: false
        },

        size: {
            type: String,
            default: 'normal'
        }
    },

    methods: {
        emitClick(e) {
            this.$emit('click', e);
        }
    }
}
</script>

<style scoped>
.app-button {
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #18AEFF;
    font-family: 'Roboto', sans-serif;
    min-width: 0;
    outline: none;
    transition: all 250ms ease-in;
}

.app-button.normal {
    height: 40px;
    border-radius: 20px;
    padding: 0px 25px;
    font-size: 14px;
    line-height: 17px;
    font-weight: 500;
}

.app-button.medium {
    height: 34px;
    border-radius: 20px;
    padding: 0px 20px;
    font-size: 12px;
    font-weight: 500;
    line-height: 17px;
}

.app-button.small {
    height: 28px;
    border-radius: 20px;
    padding: 0px 16px;
    font-size: 14px;
    line-height: 17px;
}

.app-button.link {
    padding: 0;
    background: transparent;
    color: #18aeff;
    font-weight: 400;
    font-size: 14px;
    box-shadow: none;
}

.app-button.ghost {
    background: transparent;
    color: #FFFFFF;
    border: 2px solid #FFFFFF;
}

.app-button.ghost:hover {
    background: #FFFFFF;
    color: #18AEFF;
}

.app-button.cancel-button {
    background: transparent;
    color: #877D88;
}

.app-button.cancel-button:hover {
    background: #E1E0E5;
    color: #877D88;
}

.app-button.back-button {
    background: transparent;
    color: #382153;    
    border: 2px solid #CAC6CB;
    margin-right: 30px;
}

.app-button.back-button:hover {
    background: #E1E0E5;
    color: #382153;
}

.app-button.alternate {
    background: #fff;
    color: #877D88;
    border: 2px solid #877D88;
}

.app-button.alternate:hover {
    background: #ededed;
}

.app-button:hover {
    background: #0975ae;
}

.app-button.link:hover {
    background: transparent;
}

.app-button:disabled {
    background-color: #E9E9EF;
    color: #CAC6CB;
}

.app-button .loading-dots {
    margin-left: 15px;
}

.app-button.secondary{
    background:none;
    border: 2px solid #18AEFF;
    color:#18AEFF;
    padding:0;
    font-size:14px;
    font-weight: 500;
    padding:0px 23px;
}
.app-button.secondary:hover{
    background:none;
}
</style>